import { createFileRoute } from '@tanstack/react-router'

import { MasterPairStep } from '@/pages/create-booking-page'

export const Route = createFileRoute('/_dashboard/branch/$branchId/create/_wizard/master/pair')({
    component: MasterPairStep,
})
